/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as API from "../../http/api";
import DataTable from "react-data-table-component";
import { ThemeProvider } from "@mui/material/styles";
import {theme, customStyles2} from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import moment from "moment";
import "moment/locale/es";

const ReportManualValidation = (props) => {
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [totalPage, setTotalPage] = useState(50);

  const [data, setData] = useState([]);
  const [statusCustomer, setStatus] = useState("");
  const [allStatus, setAllStatus] = useState([]);

  const dateEnd = new Date().toISOString().split("T")[0];
  const dateStart = moment().subtract(3, "months").format().split("T")[0];
  const [start_date, setStartDate] = useState(dateStart);
  const [end_date, setEndDate] = useState(dateEnd);
  const [form, setForm] = useState({
    startDate: start_date,
    endDate: end_date,
  });

  const history = useHistory();

  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setStartDate(`${dateStart}`);
    setEndDate(`${dateEnd}`);
    setData(props.content.customers);
    setTotal(props.content.metaData.total_documents);
    setPage(props.content.metaData.current_page);
    setPages(props.content.metaData.total_pages);

    let updateStatus = props.content.totals.map((item) =>
      item.status === "manual"
        ? {
            key: "manual",
            label: "Validación Manual",
            total_count: item.total_count,
          }
        : item.status == "invalidated"
        ? {
            key: "invalidated",
            label: "Inválidos",
            total_count: item.total_count,
          }
        : item.status == "validated"
        ? {
            key: "validated",
            label: "Aprobados",
            total_count: item.total_count,
          }
        : item.status == "rejected"
        ? {
            key: "rejected",
            label: "Rechazados",
            total_count: item.total_count,
          }
        : ""
    );
    setStatus(props.content.status);
    setAllStatus(updateStatus);
  };

  moment.locale("es");

  const findReport = async (execute) => {
    props.changeLoader(true);
    let dataRequest = {
      filter: {
        end_date: form.endDate,
        start_date: form.startDate,
        status: statusCustomer,
        results_per_page: totalPage,
        page_number: page,
      },
    };

    if (execute == "next") {
      dataRequest.filter.page_number = page + 1;
    }
    if (execute == "prev") {
      dataRequest.filter.page_number = page - 1;
    }
    props.changeLoader(true);

    let request = await API.service(
      "reportManualValidation",
      dataRequest,
      props.pos,
      props.changeAlert,
      props.changeLoader,
      history
    );

    if (request.status == 200 && request.data.data.response == "OK") {
      let widg = request.data.data.widget[0];
      widg["content"]["totals"] = widg["content"]["totals"]
        ? widg["content"]["totals"]
        : props.content.totals;

      setStatus(widg.content.status);
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  const dataStatus = async (e) => {
    setStatus(e.target.value);
  };

  const send = async (e) => {
    props.changeLoader(true);
    let data = {
      filter: {
        end_date: form.endDate,
        start_date: form.startDate,
        status: statusCustomer,
        results_per_page: 50,
        page_number: 1,
      },
    };
    let request = await API.service(
      "reportManualValidation",
      data,
      props.pos,
      props.changeAlert,
      props.changeLoader,
      history
    );

    if (request.status == 200 && request.data.data.response == "OK") {
      let widg = request.data.data.widget[0];
      widg["content"]["totals"] = widg["content"]["totals"]
        ? widg["content"]["totals"]
        : props.content.totals;

      setStatus(widg.content.status);
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  const changeValue = (field, e) => {
    let f = form;
    f[field] = e.target.value;
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const columns = [
    { selector: (row) => row.gname, name: "Nombre", minWidth: "11%", maxWidth: "90px", wrap: true, sortable: true},
    { selector: (row) => row.lname, name: "Apellido", minWidth: "11%", maxWidth: "90px", wrap: true, sortable: true},
    { selector: (row) => row.email, name: "Correo", minWidth: "26%", sortable: true},
    { selector: (row) => row.phone, name: "Teléfono", maxWidth: "14%", sortable: true},
    { selector: (row) => moment(new Date(row.cdate)).format("L"), name: "Fecha solicitud", sortable: true, maxWidth: "13%" },
    { selector: (row) => row.uuid, name: "UUID", wrap: true, sortable: true},
  ];

  return (
    <div className="size-12">
      <div className="resultsIn dataTopWidget">
        {allStatus.map((item) => {
          return (
            <div key={item.key} className="resultInItem">
              <span className="neutral">{item.label}</span>
              <br />
              <strong>{item.total_count}</strong>
            </div>
          );
        })}
      </div>

      <div className="card dataBlock">
        <div className="form-row">
          <i className="col-ico ibon-autodeposit inb4"></i>
          <h2 className="col-7">Resultados Validación Manual</h2>
        </div>

        <div className="inputsDate">
          <div>
            <input
              type="date"
              defaultValue={start_date}
              name="startDate"
              onChange={changeValue.bind(this, "startDate")}
              style={{ height: "30px" }}
              max={new Date().toJSON().substr(0, 10)}
            />
          </div>
          <div style={{ marginLeft: "10px" }}>
            <input
              type="date"
              defaultValue={end_date}
              name="endDate"
              onChange={changeValue.bind(this, "endDate")}
              style={{ height: "30px" }}
              max={new Date().toJSON().substr(0, 10)}
            />
          </div>
        </div>

        {/* Status -----------------------------------> */}
        <div
          className="tableToolsAbonos desktop fx-tableTipoMov"
          style={{ display: "flex" }}
        >
          <select
            value={statusCustomer}
            onChange={dataStatus.bind(this)}
            style={{ marginRight: "10px" }}
          >
            <option value={"manual"}>Validación Manual</option>
            <option value={"invalidated"}>Inválidos</option>
            <option value={"validated"}>Aprobados</option>
            <option value={"rejected"}>Rechazados</option>
          </select>
          <div className="bigButton">
            <button
              type="submit"
              style={{ padding: "5px 10px" }}
              onClick={send.bind(this)}
            >
              Buscar
            </button>
          </div>
        </div>
        {/* Paginacion -----------------------------------> */}

        <div className="tableTools justify-end" style={{ marginTop: "40px" }}>
          <span className="neutral">
            {page === 1 ? 0 : (page - 1) * totalPage + 1} -{" "}
            {totalPage * page >= total ? total : totalPage * page} de {total}
          </span>
          {page > 1 && (
            <i
              className="tap ibon-chevron-left indigo"
              onClick={findReport.bind(this, "prev")}
            ></i>
          )}
          {page < pages && (
            <i
              className="tap ibon-chevron-right indigo"
              onClick={findReport.bind(this, "next")}
            ></i>
          )}
        </div>

        {/* Tabla ------------------------------------> */}
        <div style={{ width: "100%", margin: "auto" }}>
          <ThemeProvider theme={theme}>
            <DataTable
              columns={columns}
              data={data}
              customStyles={customStyles2}
              noDataComponent={noDataComponent}
            />
          </ThemeProvider>
        </div>        
      </div>
    </div>
  );
};

export default ReportManualValidation;
